import { Theme } from '@mui/material';

export const styles = {
  card: {
    margin: '2px 2px 15px 2px',
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    columnGap: '8px',
    padding: '13px 15px',
    fontWeight: 600,
  },
  section: {
    margin: '0 0 15px 0',
  },
  grid: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: '34% 66%',
    borderBottom: 'none',
    '& .RaImageField-image': { verticalAlign: 'middle' },
    '& .MuiTypography-root': {
      fontSize: theme.typography.body1,
      margin: 0,
    },
  }),
  rowCell: {
    padding: '13px 15px',
    borderTop: '1px solid #E8E8E8',
    alignContent: 'center',
    overflow: 'auto',
  },
};
